export default [
  {
    path: '/trainResource',
    name: 'trainResource',
    component: () => import('@/trainResource/pages/index.vue'),
    meta: {
      title: '首页搜索',
      layout: {
        navBar: {
          showNavBar: false,
          showLeftArrow: false,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: [],
  },
  {
    path: '/trainResource/query',
    name: 'trainQuery',
    component: () => import('@/trainResource/pages/query/index.vue'),
    meta: {
      title: '火车票查询',
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: [],
  },
  {
    path: '/trainResource/orderDetail',
    name: 'trainOrderDetail',
    component: () => import('@/trainResource/pages/orderDetail/index.vue'),
    meta: {
      title: '订单详情',
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: [],
  },
  {
    path: '/trainResource/childDeclare',
    name: 'trainResourceChildDeclare',
    component: () => import('@/trainResource/pages/orderDetail/childDeclare.vue'),
    meta: {
      title: '选择乘客',
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: [],
  },
  {
    path: '/trainResource/seatList',
    name: 'trainResourceSeatList',
    component: () => import('@/trainResource/pages/seatList/index.vue'),
    meta: {
      title: '坐席列表',
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
      isKeepAlive: true,
    },
    children: [],
  },
  {
    path: '/trainResource/orderFill',
    name: 'trainResourceOrderFill',
    component: () => import('@/trainResource/pages/orderFill/index.vue'),
    meta: {
      title: '填写订单',
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
      isKeepAlive: true,
    },
    children: [],
  },
  {
    path: '/trainResource/orderList',
    name: 'trainOrderList',
    component: () => import('@/trainResource/pages/orderList/index.vue'),
    meta: {
      title: '火车票订单',
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: [],
  },
  {
    path: '/trainResource/bookingNotice',
    name: 'trainBookingNotice',
    component: () => import('@/trainResource/pages/bookingNotice/index.vue'),
    meta: {
      title: '预订须知',
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: [],
  },
  {
    path: '/trainResource/passengerSave',
    name: 'trainResourcePassengerSave',
    component: () => import('@/trainResource/pages/passenger/PassengerSave.vue'),
    meta: {
      title: '新增乘客',
      layout: {
        navBar: {
          showNavBar: false,
          showLeftArrow: false,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: [],
  },
  {
    path: '/trainResource/passengerSelect',
    name: 'trainResourcePassengerSelect',
    component: () => import('@/trainResource/pages/passenger/PassengerSelect.vue'),
    meta: {
      title: '选择乘客',
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: [],
  },
  {
    path: '/trainResource/refundProgress',
    name: 'trainRefundProgress',
    component: () => import('@/trainResource/pages/refundProgress/index.vue'),
    meta: {
      title: '退款进度',
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: [],
  },
  {
    path: '/trainResource/trainPay',
    component: () => import('@/trainResource/pages/trainPay/index.vue'),
    name: 'trainPay',
    meta: {
      title: '火车票支付',
      activeBar: 'order'
    },
  },
  {
    path: '/trainResource/citySelect',
    name: 'citySelect2',
    component: () => import('@/trainResource/pages/citySelect/index.vue'),
    meta: {
      title: '城市选择',
      layout: {
        navBar: {
          showNavBar: false,
          showLeftArrow: false,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: []
  },
  {
    path: '/trainResource/stationList',
    component: () => import('@/trainResource/pages/stationList/index.vue'),
    name: 'stationList',
    meta: {
      title: '车次列表',
      // 与 seatList 等同属 keep-alive 分支，从坐席页返回时不销毁列表，避免重复请求/闪烁
      isKeepAlive: true,
    },
  },
  {
    path: '/trainResource/login12306',
    name: 'trainLogin12306',
    component: () => import('@/trainResource/pages/login12306/index.vue'),
    meta: {
      title: '12306登录',
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
  },
  {
    path: '/trainResource/myPage',
    component: () => import('@/trainResource/pages/myPage/index.vue'),
    name: 'myPage',
    meta: {
      title: '我的',
    },
  },
]
